"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSMAwareHttpClient = void 0;
const axios_1 = require("axios");
const HttpClient_1 = require("auto-widget-framework/src/HttpClient/HttpClient");
const envConfig = require("../configs/env-config");
const configs_1 = require("../configs/configs");
const axiosSetCookieInterceptor_1 = require("@inchcape/automotive-axios-extensions/lib/axiosSetCookieInterceptor");
const createPostMessageTokenHook_1 = require("@inchcape/automotive-axios-extensions/lib/createPostMessageTokenHook");
const deepEqual = require("fast-deep-equal");
/**
 * We are wrapping the axios client, so that dependency on the library is in a
 * single place.
 * This way we can control the axios config from a single place.
 */
class SSMAwareHttpClient extends HttpClient_1.HttpClient {
    constructor(cookie, cookieDomain) {
        super(axios_1.default.create(SSMAwareHttpClient.getAxiosOptions()));
        this.cookieUtil = cookie;
        this.cookieDomain = cookieDomain;
        this.setUpInterceptors();
    }
    static getAxiosOptions() {
        let withCredentials = true;
        if (typeof envConfig.REACT_APP_WITH_CREDENTIALS !== undefined) {
            try {
                withCredentials = parseInt(envConfig.REACT_APP_WITH_CREDENTIALS, 10) === 1;
            }
            catch (e) {
                console.error(e);
                withCredentials = true;
            }
        }
        return { withCredentials };
    }
    setUpInterceptors() {
        const getBaseUrl = (fullUrl) => {
            const pathArray = fullUrl.split("/");
            const protocol = pathArray[0];
            const host = pathArray[2];
            return protocol + "//" + host;
        };
        if (!deepEqual(configs_1.configs.dimensions, configs_1.configs.defaultDimensions)) {
            this.instance.interceptors.request.use((config) => {
                config.params = Object.assign(Object.assign({}, configs_1.configs.dimensions), config.params);
                return config;
            });
        }
        // @TODO: Axios version mismatch.
        axiosSetCookieInterceptor_1.default(this.instance, {
            cookieDomain: envConfig.REACT_APP_SESSION_COOKIE_DOMAIN,
            cookieName: envConfig.REACT_APP_SESSION_COOKIE_NAME,
            cookieLifetime: envConfig.REACT_APP_SESSION_LIFETIME,
            requestHeaderName: envConfig.REACT_APP_SESSION_HEADER.toLowerCase(),
            responseHeaderName: envConfig.REACT_APP_SESSION_HEADER.toLowerCase(),
        }, {
            onReceive: createPostMessageTokenHook_1.default(getBaseUrl(envConfig.BE_BASE_URL))
        });
    }
}
exports.SSMAwareHttpClient = SSMAwareHttpClient;
